import styled from "styled-components";

export default styled.div<{ direction?: "column" | "row" }>`
  display: flex;
  flex-direction: ${({ direction }) => direction || "column"};
  margin-bottom: 0.5rem;
`;
